import React from "react";
import { FaCheck } from "react-icons/fa6";


interface PackageProps {
  packageData: {
    id: string;
    name: string;
    hours: number;
    expiryDays: number;
    expiryMonths?: number | null;
    taxIncluded?: boolean;
    price: number;
    features: string[];
  };
  onSelectPackage: (id: string) => void;
}

function FullCompass({ packageData, onSelectPackage }: PackageProps) {
  return (
    <div>
      <div>
        <div className="rounded-t-3xl border-2 border-b-0 border-[#27335D] bg-[#27335d]">
          <h1 className="py-3.5 text-center text-3xl font-bold text-white xsm:py-2 xsm:text-base sm:py-2.5 sm:text-lg md:text-xl lg:py-[20px] lg:text-2xl">
            {packageData.name}
          </h1>
        </div>
      </div>
      <div className="border-2 border-b-0 border-t-0 border-[#27335D] bg-white pb-5">
        <div className="rounded-b-4xl border-2 border-x-0 border-t-0 border-[#27335D] bg-[#75C9EB] shadow-custom">
          <h1 className="py-0.5 text-center text-4xl font-bold text-[#27335d] xsm:py-0.5 xsm:text-lg sm:py-1 sm:text-xl md:text-2xl lg:py-3.5 lg:text-3xl">
            ${packageData.price}
            {packageData.taxIncluded && <span className="block text-xs font-normal">VAT included</span>}
          </h1>
        </div>
      </div>
      <div className="rounded-b-3xl border-2 border-t-0 border-[#27335D] bg-white px-8 text-xl font-bold text-[#27335D] xsm:px-2 xsm:text-xs sm:px-4 sm:text-sm md:px-5 md:pt-5 md:text-base lg:px-6 lg:text-lg">
        <div>
          {/* Feature 1 */}
          <div className="flex items-center gap-4 py-2 xsm:gap-1 xsm:py-0.5 sm:gap-2 sm:py-0.5 md:gap-2 md:py-1 lg:gap-3 lg:py-1.5">
            <div className="rounded-md border-2 border-[#4887F5] bg-[#DDF1FA] p-1 text-[#4887F5] sm:p-0.5 md:p-0.5 lg:p-0.5">
              <FaCheck />
            </div>
            <p className="text-[1.4rem] xsm:text-xs sm:text-sm md:text-base lg:text-lg">
              1:1 Private sessions
            </p>
          </div>
          {/* Feature 2 */}
          <div className="flex items-center gap-4 py-2 xsm:gap-1 xsm:py-0.5 sm:gap-2 sm:py-0.5 md:gap-2 md:py-1 lg:gap-3 lg:py-1.5">
            <div className="rounded-md border-2 border-[#4887F5] bg-[#DDF1FA] p-1 text-[#4887F5] sm:p-0.5 md:p-0.5 lg:p-0.5">
              <FaCheck />
            </div>
            <p className="text-[1.4rem] xsm:text-xs sm:text-sm md:text-base lg:text-lg">
              Pick your favorite tutor
            </p>
          </div>
          {/* Feature 3 */}
          <div className="flex items-center gap-4 py-2 xsm:gap-1 xsm:py-0.5 sm:gap-2 sm:py-0.5 md:gap-2 md:py-1 lg:gap-3 lg:py-1.5">
            <div className="rounded-md border-2 border-[#4887F5] bg-[#DDF1FA] p-1 text-[#4887F5] sm:p-0.5 md:p-0.5 lg:p-0.5">
              <FaCheck />
            </div>
            <p className="text-[1.4rem] xsm:text-xs sm:text-sm md:text-base lg:text-lg">
              <span className="text-[#4887F5]">
                {packageData.hours}h{" "}
              </span>
              of learning time
            </p>
          </div>
          {/* Feature 4 */}
          <div className="flex items-center gap-4 py-2 xsm:gap-1 xsm:py-0.5 sm:gap-2 sm:py-0.5 md:gap-2 md:py-1 lg:gap-3 lg:py-1.5">
            <div className="rounded-md border-2 border-[#4887F5] bg-[#DDF1FA] p-1 text-[#4887F5] sm:p-0.5 md:p-0.5 lg:p-0.5">
              <FaCheck />
            </div>
            <p className="text-[1.4rem] xsm:text-xs sm:text-sm md:text-base lg:text-lg">
              Schedule sessions your way
            </p>
          </div>
          <div className="flex items-center gap-4 py-2 xsm:gap-1 xsm:py-0.5 sm:gap-2 sm:py-0.5 md:gap-2 md:py-1 lg:gap-3 lg:py-1.5">
            <div className="rounded-md border-2 border-[#4887F5] bg-[#DDF1FA] p-1 text-[#4887F5] sm:p-0.5 md:p-0.5 lg:p-0.5">
              <FaCheck />
            </div>
            <p className="text-[1.4rem] xsm:text-xs sm:text-sm md:text-base lg:text-lg">
              Credits valid for{" "}
              <span className="text-[#4887F5]">
                {packageData.expiryMonths ? `${packageData.expiryMonths} months` : `${packageData.expiryDays} days`}
              </span>
            </p>
          </div>
        </div>
        <div className="flex justify-center py-3 md:py-7">
          <button
            onClick={() => onSelectPackage(packageData.id)}
            data-testid="packageFullCompassButton"
            className="cursor-pointer py-4.5 md:py-2. transform-gpu rounded-full border-b-4 border-[#4d4d4d] bg-[#27335D] px-12 text-[1.4rem] font-bold text-[#E9E9EA] transition-all duration-300 ease-out hover:bg-[#3666b9] active:scale-95 xsm:px-4 xsm:py-2 xsm:text-xs sm:px-6 sm:py-2.5 sm:text-sm md:bg-[#1849A9] md:px-8 md:text-base lg:px-10 lg:py-3 lg:text-lg"
          >
            Get {packageData.hours}h now
          </button>
        </div>
      </div>
    </div>
  );
}

export default FullCompass;
